import * as Yup from "yup";

export interface CustomerCheckoutDetail {
  amount: string;
  email: string;
  phone: string;
  billingName: string;
  address: string;
  city: string;
  country: string;
  state: string;
  zip: string;
  transactionReference: string;
  cashierId: string;
  dmsSetupId?: string;
}
export const CustomerCheckoutInitialValues: CustomerCheckoutDetail = {
  amount: "",
  email: "",
  phone: "",
  billingName: "",
  address: "",
  city: "",
  state: "",
  country: "",
  zip: "",
  transactionReference: "",
  cashierId: "",
  dmsSetupId: "",
};

export const CustomerCheckoutValidationSchema = Yup.object().shape({
  billingName: Yup.string().required("Please Enter your Name"),
  email: Yup.string().required("Please Enter Email").email("Invalid Email"),
  phone: Yup.string()
    .required("Please Enter Phone")
    .min(7, "Enter valid Phone"),
  address: Yup.string().required("Address is required for shipping"),
  zip: Yup.string().required("Zip is required"),
});
